/**
 * Check if the current user is already authenticated, if he is,
 * then check is he on the right user for the given authentication code
 * @param authenticationCode
 */
import { useEffect, useState } from 'react';
import * as api from '../../api';

export const useIsAuthenticated = (authenticationCode: string) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isPending, setIsPending] = useState(true);
  useEffect(() => {
    const verifyAuthentication = async () => {
      try {
        const isAuthenticated = await api.client.Previsit.isAuthenticated();
        if (!isAuthenticated) {
          setIsPending(false);
          return;
        }
        // Make sure they're logged in as the correct user
        await api.client.Previsit.fetchFormSets(authenticationCode);
        setIsAuthenticated(true);
        setIsPending(false);
      } catch (e) {
        setIsPending(false);
      }
    };
    verifyAuthentication();
  }, [setIsAuthenticated, authenticationCode]);
  return { isAuthenticated, isPending };
};
